import { Dialog, DialogContent, DialogHeader, DialogFooter } from '@/shared/ui/dialog';
import { Button } from '@/shared/ui/button';

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  receivableId: string;
  onConfirm: () => void;
  isDeleting: boolean;
}

export function ReceivableDeleteDialog({ open, onOpenChange, receivableId, onConfirm, isDeleting }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>Confirmação de Exclusão</DialogHeader>
        <div>Tem certeza que deseja excluir o recebível <span className="font-mono">{receivableId}</span>?</div>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)} disabled={isDeleting}>Cancelar</Button>
          <Button variant="destructive" onClick={onConfirm} >Excluir</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
